import InspirationBentoGrid, { mapTables } from "@/components/organisms/inspiration-bento-grid";
import OurServices from "@/components/organisms/our-services";
import StageHeader from "@/components/organisms/stage-header";
import { generateSEO } from "@/helpers/seo";
import { getAllByType } from "@/lib/prismic";
import { getData } from "@/lib/prismic/data";
import { ArchiveTableDocument, TablesDocument } from "@/prismicio-types";
import { notFound } from "next/navigation";
import { use } from "react";

const ArchiveTables = ({ resolution }: TemplateProps) => {
  const document = use(getData({ ...resolution, templateName: "archive_table" })) as ArchiveTableDocument | null;

  if (!document || !document.data) return notFound();

  const { title, introduction } = document.data;

  const tablesResults = use(getAllByType("tables", resolution.locale));

  const tables = mapTables(tablesResults as TablesDocument[], resolution.locale);

  return (
    <>
      <StageHeader
        locale={resolution.locale}
        className="md:my-4 max-md:[&_h1]:mt-4"
        orientationOnMobile="center"
        hideDescriptionOnMobile
        title={title}
        description={introduction}
      />
      <InspirationBentoGrid inspirationCategories={tables} />
      <OurServices locale={resolution.locale} className="lg:hidden" />
    </>
  );
};

export default ArchiveTables;

ArchiveTables.generateMetadata = async (resolution: Resolution) => {
  const document = (await getData({
    ...resolution,
    templateName: "archive_table",
  })) as ArchiveTableDocument | null;

  if (!document || !document.data) {
    return {};
  }

  return generateSEO(document, resolution.locale);
};
